module.exports = __webpack_public_path__ + "static/img/07-03.b479ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/07-03.png
// module id = C0Zh
// module chunks = 0